import React, { forwardRef } from 'react';
import clsx from 'clsx';
import tokens from '@talent-garden/design-dictionary/platforms/web/tokens.json';
import { flex as flexClass } from './flex.module.css';
const prefixProp = (prop) => {
    if (prop.includes('start') || prop.includes('end')) {
        return `flex-${prop}`;
    }
    return prop;
};
export const Flex = forwardRef(({ children, className, rowGap = 0, columnGap = 0, as: Wrapper = 'div', inline = false, direction = 'column', wrap = false, grow = false, verticalAlign = 'initial', horizontalAlign = 'initial', horizontalPadding = 0, verticalPadding = 0, style, ...props }, forwardedRef) => {
    const cssVars = {
        '--row-gap': rowGap && tokens.space[rowGap],
        '--column-gap': columnGap && tokens.space[columnGap],
        '--vertical-align': verticalAlign && prefixProp(verticalAlign),
        '--horizontal-align': horizontalAlign && prefixProp(horizontalAlign),
        '--vertical-padding': verticalPadding && tokens.space[verticalPadding],
        '--horizontal-padding': horizontalPadding && tokens.space[horizontalPadding]
    };
    return (React.createElement(Wrapper, { ref: forwardedRef, style: { ...cssVars, ...style }, "data-flex-inline": inline, "data-flex-wrap": wrap, "data-flex-direction": direction, "data-flex-grow": grow, className: clsx(flexClass, className), ...props }, children));
});
Flex.displayName = 'Flex';
